export default __webpack_public_path__ + "static/media/platform_support.ff3e5dc9.png";